import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
import marketplaceIcon from '../../assets/shopping_cart.svg';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums';
import { getMarketPlace } from '../../store/marketPlace/actions';

export default function ShopMarketPlace({ handleloadinTiming }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const marketPlaceFilter = { query: '', marketPlaceTypeIds: [], sort: 6 };
    const { marketPlaceList } = useSelector(state => state.marketPlace);

    const [hasExtraItems, setHasExtraItems] = useState(false);

    useEffect(() => {
        document.title = 'MarketPlace | CWP Team Connect';
        dispatch(showLoading());
        handleloadinTiming(shopMonitorSliderTime.LeadingTime);
    }, []);

    useEffect(() => {
        dispatch(getMarketPlace(marketPlaceFilter)).unwrap().then(() => {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
            setIsDataLoaded(true);
        });
    }, [dispatch]);

    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);

    useEffect(() => {
        // Check if marketplace-listing-items exceed 3
        if (marketPlaceList?.length > 3) {
            setHasExtraItems(true);
        } else {
            setHasExtraItems(false);
        }
    }, [marketPlaceList]);

    return (
        <div className="monitors-inner">
            <div className="monitors-item marketplace-info-item">
                <div className="monitors-header-wrap">
                    <p className="monitors-header-title">Market Place</p>
                    <span className="monitors-header-icon"><img src={marketplaceIcon} alt="Marketplace Icon" /></span>
                </div>
                <div className="monitors-item-event-wrap marketplace-item-column-wrap">
                    {/* Conditionally apply the class */}
                    <div className={`marketplace-listing-wrap ${hasExtraItems ? 'extra-items' : ''}`}>
                        {marketPlaceList && marketPlaceList.length > 0 && (
                            marketPlaceList.slice(0, 8).map((item, index) => {
                                return (
                                    <a
                                        key={index}
                                        onClick={() => navigate('/marketplace-details/' + item.baseId)}
                                        className={`marketplace-listing-item ${item?.media?.length > 0 ? 'listing-item-img' : ''}`}
                                    >
                                        {item?.media && item?.media.length > 0 && (
                                            <span className="marketplace-img-holder">
                                                <img
                                                    src={item?.media[0]?.mediaItem?.previewsrc}
                                                    className="marketplace-img"
                                                    alt={item?.media[0]?.mediaItem?.altText || "marketplace item"}
                                                    loading="lazy"
                                                />
                                            </span>
                                        )}
                                        <span className="marketplace-top-info-wrap">
                                            <span className="marketplace-value">{item?.amountInfo}
                                                {item?.amountType && (
                                                    <span className="marketplace-value-desc">{item?.amountType}</span>
                                                )}
                                            </span>
                                        </span>
                                        <span className="marketplace-information-wrap">
                                            <span className="marketplace-info-container">
                                                <span className="marketplace-information-inner">
                                                    <span className="marketplace-title-wrap">{item?.title}</span>
                                                    <span className="marketpalce-desc-wrap"></span>
                                                </span>
                                                <span className="marketplace-info-wrap">
                                                    <span className="marketplace-location">{item?.location}</span>
                                                </span>
                                            </span>
                                        </span>
                                    </a>

                                );
                            })
                        )}
                    </div>
                </div>
            </div>
            <Sidebar pageType={"marketplace"} />
        </div>
    );
}

ShopMarketPlace.propTypes = {
    handleloadinTiming: PropTypes.func
};
